export default __webpack_public_path__ + "792f02ba91f3c6e1094113b39efa0bc8.svg";